import React from 'react';
import {
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    TextField,
} from '@fluentui/react';
import {Dropdown} from '@fluentui/react/lib/Dropdown';
import {
    useAddWorkspaceMutation,
    useAddWorkspaceWithTemplateDefaultsMutation,
    useGetTemplateWorkspacesQuery,
} from '../../store/Api';
import {useImportWorkspaceProductsFromTemplateMutation} from '../../store/endpoints/WorkspaceItemsEndpoints';

interface ICreateWorkspaceDialogProps {
    isOpen: boolean;
    onDismiss: () => void;
    onCreated: (workspaceId: string) => void;
}

// The Create New Workspace dialog, extracted from WorkspaceControls so it can also be
// launched from the global search palette. The caller decides what to do with the new id.
const CreateWorkspaceDialog: React.FC<ICreateWorkspaceDialogProps> = props => {
    const getWorkspaceTemplates = useGetTemplateWorkspacesQuery(undefined, {skip: !props.isOpen});
    const [addWorkspace] = useAddWorkspaceMutation();
    const [addWorkspaceFromTemplate] = useAddWorkspaceWithTemplateDefaultsMutation();
    const [importProducts] = useImportWorkspaceProductsFromTemplateMutation();
    const [newWorkspaceName, setNewWorkspaceName] = React.useState('');
    const [workspaceToImport, setWorkspaceToImport] = React.useState<string | number | undefined>('');

    const workspaceAddFinish = () => {
        if (workspaceToImport) {
            addWorkspaceFromTemplate({name: newWorkspaceName, template: workspaceToImport.toString()})
                .then((result: any) => {
                    if (result?.data?.id) {
                        if (workspaceToImport) {
                            importProducts({sourceId: workspaceToImport.toString(), destinationId: result.data.id});
                        }
                        props.onCreated(result.data.id);
                    }
                    props.onDismiss();
                });
        } else {
            addWorkspace(newWorkspaceName).then((result: any) => {
                if (result?.data?.id) {
                    props.onCreated(result.data.id);
                }
                props.onDismiss();
            });
        }
    };

    const getWorkspaceTemplateEntries = () => {
        const blank = {key: `noTemplate`, text: `[Not Selected]`};
        const values = getWorkspaceTemplates.data ?
            getWorkspaceTemplates.data.map(a => ({key: a.id, text: a.name})) : [];

        values.splice(0, 0, blank);
        return values;
    };

    return (
        <Dialog
            hidden={!props.isOpen}
            onDismiss={props.onDismiss}
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: 'Create New Workspace',
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            <TextField label='Workspace Name'
                       onChange={(e, v) => setNewWorkspaceName(v ?? '')}
                       onKeyDown={(e) => {if (e.key === "Enter") workspaceAddFinish()}}
            />
            <br/>
            {getWorkspaceTemplates.data && <Dropdown
                dropdownWidth={0}
                options={getWorkspaceTemplateEntries()}
                selectedKey={workspaceToImport ?? `noTemplate`}
                label={"Workspace Item Template (Optional)"}
                onChange={(e, a) => {
                    if (a?.key == 'noTemplate') {
                        setWorkspaceToImport(undefined)
                    }
                    else {
                        setWorkspaceToImport(a?.key)
                    }
                }}
            />}
            <br/>
            <DialogFooter>
                <DefaultButton
                    primary
                    disabled={newWorkspaceName == undefined || newWorkspaceName == ``}
                    text='Create'
                    onClick={workspaceAddFinish}
                />
                <DefaultButton
                    text='Cancel'
                    onClick={props.onDismiss}
                />
            </DialogFooter>
        </Dialog>
    );
};

export default CreateWorkspaceDialog;
